import * as Sentry from '@sentry/browser';

Sentry.init({
  debug: import.meta.env.DEV,
  enabled: import.meta.env.PROD,
  release: import.meta.env.VITE_SENTRY_RELEASE,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENV,
});

const toError = (error) => {
  if (error instanceof Error) {
    return error;
  }

  if (error && typeof error === 'object') {
    const reconstructed = new Error(error.message ?? 'Unknown error');
    if (error.name) {
      reconstructed.name = error.name;
    }
    if (error.stack) {
      reconstructed.stack = error.stack;
    }
    if (error.code !== undefined) {
      reconstructed.code = error.code;
    }
    return reconstructed;
  }

  return new Error(typeof error === 'string' ? error : 'Unknown error');
};

export const sentryMiddleware = (store) => (next) => (action) => {
  if (action.error) {
    Sentry.withScope((scope) => {
      scope.setExtras({
        action,
        state: store.getState(),
      });
      Sentry.captureException(toError(action.error));
    });
  }
  return next(action);
};

export default Sentry;
